<template v-cloak>
    <NuxtLayout name="main" :class="i18n.locale.value === 'en' ? 'en' : 'zh'">
        <section class="header-container">
            <div class="text-[56px] text-white font-bold container">{{ $t("UserAgreement") }}</div>
        </section>

        <section class="flex items-center h-[64px] bg-uicolor5">
            <div class="container">{{ $t("Home.Name") }} > {{ $t("AboutUs") }} > {{ $t("UserAgreement") }}</div>
        </section>

        <section class="content-container container">
            <div class="text-[44px] leading-[76px] text-emphas font-bold">{{ $t("UserAgreementI18n.Title") }}</div>

            <div class="paragraph">
                <p v-html="$t('UserAgreementI18n.Descript1')"></p>
            </div>

            <div class="paragraph mt-[54px]">
                <h2 v-html="$t('UserAgreementI18n.Section1')"></h2>
                <ol>
                    <li v-html="$t('UserAgreementI18n.Descript2')"></li>
                    <li v-html="$t('UserAgreementI18n.Descript3')"></li>
                    <li v-html="$t('UserAgreementI18n.Descript4')"></li>
                </ol>
            </div>

            <div class="paragraph">
                <h2 v-html="$t('UserAgreementI18n.Section2')"></h2>
                <ol>
                    <li v-html="$t('UserAgreementI18n.Descript5')"></li>
                    <li v-html="$t('UserAgreementI18n.Descript6')"></li>
                    <li v-html="$t('UserAgreementI18n.Descript7')"></li>
                    <li v-html="$t('UserAgreementI18n.Descript8')"></li>
                </ol>
            </div>

            <div class="paragraph">
                <h2 v-html="$t('UserAgreementI18n.Section3')"></h2>
                <ol>
                    <li v-html="$t('UserAgreementI18n.Descript9')"></li>
                    <li v-html="$t('UserAgreementI18n.Descript10')"></li>
                    <div class="pl-[36px]">
                        <p v-html="$t('UserAgreementI18n.Descript11')"></p>
                        <p v-html="$t('UserAgreementI18n.Descript12')"></p>
                        <p v-html="$t('UserAgreementI18n.Descript13')"></p>
                        <p v-html="$t('UserAgreementI18n.Descript14')"></p>
                        <p v-html="$t('UserAgreementI18n.Descript15')"></p>
                        <p v-html="$t('UserAgreementI18n.Descript16')"></p>
                        <p v-html="$t('UserAgreementI18n.Descript17')"></p>
                    </div>
                </ol>
            </div>

            <div class="paragraph">
                <h2 v-html="$t('UserAgreementI18n.Section4')"></h2>
                <ol>
                    <li v-html="$t('UserAgreementI18n.Descript18')"></li>
                    <li v-html="$t('UserAgreementI18n.Descript19')"></li>
                    <li v-html="$t('UserAgreementI18n.Descript20')"></li>
                    <li v-html="$t('UserAgreementI18n.Descript21')"></li>
                </ol>
            </div>

            <div class="paragraph">
                <h2 v-html="$t('UserAgreementI18n.Section5')"></h2>
                <ol>
                    <li v-html="$t('UserAgreementI18n.Descript22')"></li>
                    <li v-html="$t('UserAgreementI18n.Descript23')"></li>
                    <li v-html="$t('UserAgreementI18n.Descript24')"></li>
                </ol>
            </div>

            <div class="paragraph">
                <h2 v-html="$t('UserAgreementI18n.Section6')"></h2>
                <ol>
                    <li v-html="$t('UserAgreementI18n.Descript25')"></li>
                    <li v-html="$t('UserAgreementI18n.Descript26')"></li>
                    <li v-html="$t('UserAgreementI18n.Descript27')"></li>
                    <li v-html="$t('UserAgreementI18n.Descript28')"></li>
                </ol>
            </div>
            <div class="paragraph">
                <h2 v-html="$t('UserAgreementI18n.Section7')"></h2>
                <ol>
                    <li v-html="$t('UserAgreementI18n.Descript29')"></li>
                    <li v-html="$t('UserAgreementI18n.Descript30')"></li>
                    <li v-html="$t('UserAgreementI18n.Descript31')"></li>
                    <li v-html="$t('UserAgreementI18n.Descript32')"></li>
                </ol>
            </div>
            <div class="paragraph">
                <h2 v-html="$t('UserAgreementI18n.Section8')"></h2>

                <p v-html="$t('UserAgreementI18n.Descript33')"></p>
                <p v-html="$t('UserAgreementI18n.Descript34')"></p>
            </div>
        </section>
    </NuxtLayout>
</template>

<script lang="ts" setup>
const i18n = useI18n();
</script>

<style lang="less" scoped>
.header-container {
    display: flex;
    align-items: center;
    width: 100%;
    height: 300px;
    background: url("@/assets/images/user-agreement/header-cover.webp") center no-repeat;
    background-size: cover;
}

.content-container {
    margin: 64px auto 0;
    counter-reset: section;
    .paragraph {
        margin: 64px 0 0;

        > * {
            margin-top: 32px;
        }
    }
    h2 {
        position: relative;
        display: flex;
        align-items: center;
        color: var(--uicolor-font-1);
        padding-left: 36px;
        font-size: 20px;
        line-height: 36px;
        counter-increment: section;
        &::before {
            content: counter(section) ".";
        }
        &::after {
            position: absolute;
            top: 0;
            left: 0;
            content: "";
            width: 16px;
            height: 34px;
            background: url("@/assets/images/privacy/icon-item-443c805b-41d4-4b15-b6d9-3cf7d5d60769.webp") center no-repeat;
            background-size: contain;
        }
    }
    ol {
        margin: 0;
        padding: 0;
        list-style: none;
        counter-reset: level1;
        > li {
            padding-inline-start: 36px;
            text-indent: -36px;
            &:not(:first-child) {
                margin-top: 16px;
            }
            &::before {
                padding-right: 14px;
                font-weight: bold;
                color: var(--uicolor-font-1);
                counter-increment: level1;
                content: counter(section) "." counter(level1);
            }
        }
    }
}
</style>
